<div class="ui-g ui-fluid">
  <div class="ui-g-12 ui-lg-12">
    <div class="card card-w-title">
      <h1>Order Tasks</h1>

      <div class="ui-grid-row" style="margin-top: 30px" [hidden]="!isLoaded">
        <p-table
          selectionMode="single"
          [value]="orderTasks"
          [responsive]="true"
          rowHover="true"
          resizableColumns="true"
          [(selection)]="selectedTask"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>From</th>
              <th>To</th>
              <th>Earliest Pickup</th>
              <th>Latest Dropoff</th>
              <th>Earliest Pickup</th>
              <th>Latest Dropoff</th>
              <th>Movement Type</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item">
              <td>{{ item.pickupLocation.primaryAddress }}</td>
              <td>{{ item.dropoffLocation.primaryAddress }}</td>
              <td>{{ item.pickupEarliestDateTime | datex : 'ddd DD MMM HH:mm' }}</td>
              <td>{{ item.pickupLatestDateTime | datex : 'ddd DD MMM HH:mm' }}</td>
              <td>{{ item.dropoffEarliestDateTime | datex : 'ddd DD MMM HH:mm' }}</td>
              <td>{{ item.dropoffLatestDateTime | datex : 'ddd DD MMM HH:mm' }}</td>
              <td>{{ item.taskType.name }}</td>
            </tr>
          </ng-template>
        </p-table>

        <!--- DATATABLES DEPRECATED ---
             <p-dataTabl selectionMode="single" [value]="orderTasks" [responsive]="true" rowHover="true" resizableColumns="true"
                       [(selection)]="selectedTask">

              <p-column field="pickupLocation.primaryAddress" header="From" [editable]="false" [style]="{'width': '22%'}">
                  <ng-template pTemplate="body" let-item="rowData">
                      {{item.pickupLocation.primaryAddress}}
                  </ng-template>
              </p-column>
              <p-column field="dropoffLocation.primaryAddress" header="To" [editable]="false" [style]="{'width': '22%'}">
                  <ng-template pTemplate="body" let-item="rowData">
                      {{item.dropoffLocation.primaryAddress}}
                  </ng-template>
              </p-column>
              <p-column field="pickupEarliestDateTime" header="Earliest Pick-up" [editable]="false" [style]="{'width': '9%'}">
                  <ng-template pTemplate="body" let-item="rowData">
                      {{item.pickupEarliestDateTime | datex:'ddd DD MMM HH:mm'}}
                  </ng-template>
              </p-column>
              <p-column field="pickupLatestDateTime" header="Latest Pick-up" [editable]="false" [style]="{'width': '9%'}">
                  <ng-template pTemplate="body" let-item="rowData">
                      {{item.pickupLatestDateTime | datex:'ddd DD MMM HH:mm'}}
                  </ng-template>
              </p-column>
              <p-column field="dropoffEarliestDateTime" header="Earliest Drop-Off" [editable]="false" [style]="{'width': '9%'}">
                  <ng-template pTemplate="body" let-item="rowData">
                      {{item.dropoffEarliestDateTime | datex:'ddd DD MMM HH:mm'}}
                  </ng-template>
              </p-column>
              <p-column field="dropoffLatestDateTime" header="Latest Drop-Off" [editable]="false" [style]="{'width': '9%'}">
                  <ng-template pTemplate="body" let-item="rowData">
                      {{item.dropoffLatestDateTime | datex:'ddd DD MMM HH:mm'}}
                  </ng-template>
              </p-column>
              <p-column field="taskType.name" header="Movement Type" [editable]="false" [style]="{'width': '20%'}"></p-column>
          </p-dataTable>

          -->
      </div>

      <div class="ui-grid-row" style="margin-top: 20px">
        <button
          type="button"
          (click)="close()"
          pButton
          icon="fa ui-icon-close"
          label="Close"
          class="btn-to-right"
        ></button>
      </div>
    </div>
  </div>
</div>
